import {createSlice} from '@reduxjs/toolkit';
//types
import {IUserNotificationSettingReducer} from '../../utils/types';
//actions
import {userGetNotificationSettings, userUpdateNotificationSettings} from './actions';
//operations
import {pendingOperation, rejectedOperation, getNotificationSetting, updateNotificationSetting} from './operations';

export const initialState: IUserNotificationSettingReducer = {
	userSetting: null,
	isLoading: false,
};

const userNotificationStore = createSlice({
	name: 'userNotification',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(userGetNotificationSettings.pending, pendingOperation);
		builder.addCase(userGetNotificationSettings.fulfilled, getNotificationSetting);
		builder.addCase(userGetNotificationSettings.rejected, rejectedOperation);

		builder.addCase(userUpdateNotificationSettings.pending, pendingOperation);
		builder.addCase(userUpdateNotificationSettings.fulfilled, updateNotificationSetting);
		builder.addCase(userUpdateNotificationSettings.rejected, rejectedOperation);
	},
});

export default userNotificationStore.reducer;
